// src/portal-app/shell/kit/VerdictCard.js
//
// The P1 (Digest Scroll) headline for Insights and Operations.
//
// Its most important behaviour is what it does with NOTHING to say. A verdict
// must state a comparison or a consequence — "Takings are running 31% below a
// normal Tuesday", not "Service is running smoothly". When the caller cannot
// compute such a line it passes no `sentence`, and this card renders the stats
// and sparkline alone rather than emitting filler. See spec §5 P1.
import React from 'react';
import { GlassCard } from '../LiquidGlass';
import { ensureKitCss } from './kitCss';
import { Sparkline } from './Sparkline';

export function VerdictCard({ label, sentence, stats, points, sparkAriaLabel }) {
    ensureKitCss();

    // Whitespace-only counts as absent — callers building a sentence by
    // concatenation can otherwise pass '' or '  ' without noticing.
    const hasSentence = typeof sentence === 'string' && sentence.trim().length > 0;
    const list = Array.isArray(stats) ? stats : [];

    return (
        <GlassCard veil className="pk-verdict" data-testid="verdict-card">
            {label && <div className="pk-label">{label}</div>}

            {hasSentence && (
                <p className="pk-verdict-sentence">{sentence}</p>
            )}

            {list.length > 0 && (
                <div className="pk-verdict-stats">
                    {list.map((s, i) => (
                        <div className="pk-verdict-stat" key={`${s.caption || ''}#${i}`}>
                            <div className="pk-verdict-stat-value pk-num">{s.value}</div>
                            {s.caption && <div className="pk-verdict-stat-caption">{s.caption}</div>}
                        </div>
                    ))}
                </div>
            )}

            {Array.isArray(points) && points.length >= 2 && (
                <div className="pk-verdict-spark">
                    <Sparkline points={points} ariaLabel={sparkAriaLabel} />
                </div>
            )}
        </GlassCard>
    );
}

export default VerdictCard;
